import { Injectable, inject } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BdHubspotFormService {
  private readonly _http = inject(HttpClient);


  public sendForm(
    portalId: string,
    formId: string,
    fields: {name: string, value: string}[],
    consentCommunications: boolean,
    pageUrl: string,
    pageName: string
  ): Observable<unknown> {

    fields = fields.filter(field => !!field.value);

    const url = `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`;
    const hubSpotUserToken = this._getCookie('hubspotutk');
    const context: {
      hutk?: string;
      pageUri: string;
      pageName: string;
    } = {
      pageUri: pageUrl,
      pageName: pageName,
    };

    if (hubSpotUserToken) {
      context.hutk = hubSpotUserToken;
    }

    return this._http.post(url, {
      'fields': fields,
      'context': context,
      'legalConsentOptions': {
        'consent': {
          'consentToProcess': true,
          'text': 'Indem Sie unten auf „Einsenden“ klicken, stimmen Sie zu, dass BinDoc die oben angegebenen persönlichen Daten speichert und verarbeitet, um Ihnen die angeforderten Inhalte bereitzustellen.',
          'communications': [
            {
              'value': consentCommunications,
              'subscriptionTypeId': 5651662,
              'text': 'Ich stimme zu, andere Benachrichtigungen von BinDoc zu erhalten.'
            }
          ]
        }
      }
    });
  }

  private _getCookie(name: string): string {
    const ca: Array<string> = document.cookie.split(';');
    const caLen: number = ca.length;
    const cookieName = `${name}=`;
    let c: string;

    for (let i = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) === 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return '';
  }
}
